module.exports = __webpack_public_path__ + "img/empty-list.5943104.png";